<template>
    <div class="m-main">
        <span class="m-title" v-html="$t('mult_table')"></span>
        <div class="mult-tab">
            <v-card class="mt-card" v-for="i in 10" :key="i">
                <div class="mt-title mt-txt">{{i}}</div>
                <div class="mt-txt" v-for="j in 10" :key="j">
                    {{i}} × {{j}} = {{i * j}}
                </div>
            </v-card>
        </div>
    </div>
</template>

<script async src="https://www.googletagmanager.com/gtag/js?id=G-8S0M681ZDD"></script>
<script>
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
export default {
  name: 'MultTable'
}
</script>

<style scoped>
.m-main{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    padding: 30px;
}
.m-title{
    font-weight: 600;
    font-size: 30px;
    padding-bottom: 20px;
}
.mult-tab{
    display: flex;
    flex-direction: row;
    gap: 8px;
    flex-wrap: wrap;
    min-width: 130px;
}
.mt-card{
    width: 150px;
    text-align: center;
}
.mt-title{
    background-color: rgba(112,118,131,0.3);
    font-weight: bold;
}
.mt-txt{
    padding: 4px 0;
}
</style>
